import React from "react";
import { formatAddressTwoLines } from "src/utils";
import type { DigiFiCustomer } from "src/types/conditionsInbox";
import {
  CustomerDetails,
  DetailRow,
  DetailLabel,
  DetailValue,
} from "./SearchSection.styles";

interface CustomerDetailsSectionProps {
  customer: DigiFiCustomer;
}

export const CustomerDetailsSection: React.FC<CustomerDetailsSectionProps> = ({
  customer,
}) => (
  <CustomerDetails>
    <DetailRow>
      <DetailLabel>Borrower:</DetailLabel>
      <DetailValue>{customer.name}</DetailValue>
    </DetailRow>
    {customer.coBorrower && (
      <DetailRow>
        <DetailLabel>Co-Borrower:</DetailLabel>
        <DetailValue>{customer.coBorrower}</DetailValue>
      </DetailRow>
    )}
    {customer.intermediary && (
      <DetailRow>
        <DetailLabel>Intermediary:</DetailLabel>
        <DetailValue>{customer.intermediary}</DetailValue>
      </DetailRow>
    )}
    <DetailRow>
      <DetailLabel>
        Borrower: <br /> Address
      </DetailLabel>
      <DetailValue>
        {customer.address && formatAddressTwoLines(customer.address)}
      </DetailValue>
    </DetailRow>
  </CustomerDetails>
);
